'use client'

import React, { useState } from 'react'
import { Tooltip } from 'react-tooltip'

const features = [
  {
    icon: '🌐',
    title: "Simplified Cross-Border Compliance",
    desc: "Streamline compliance processes across different countries and regions."
  },
  {
    icon: '🗣️',
    title: "Multilingual Support",
    desc: "Support multiple languages and various data formats for comprehensive processing."
  },
  {
    icon: '📄',
    title: "Automated Document Generation",
    desc: "Automatically generate necessary compliance documents and reports."
  },
  {
    icon: '🔄',
    title: "Real-Time Regulatory Updates",
    desc: "Receive real-time updates on changes in regulations and compliance requirements."
  },
  {
    icon: '💰',
    title: "Global Incentives Access",
    desc: "Identify and access global incentives and subsidies for compliance."
  },
  {
    icon: '📈',
    title: "Enhanced Market Intelligence",
    desc: "Gain insights into market trends and compliance landscapes."
  },
]

export default function FeaturesSection() {
  const [activeFeature, setActiveFeature] = useState(0)

  return (
    <section className="py-20 bg-gradient-to-b from-white to-blue-50" id='features'>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase">Features</h2>
          <p className="mt-2 text-3xl font-extrabold text-gray-900 sm:text-4xl lg:text-5xl">
            Empower Your Global Compliance
          </p>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto">
            Discover how our cutting-edge features revolutionize cross-border compliance management.
          </p>
        </div>

        <div className="mt-20">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
            {features.map((feature, index) => (
              <div
                key={index}
                className={`relative p-6 bg-white rounded-lg shadow-md transition-all duration-300 ease-in-out transform hover:scale-105 ${
                  activeFeature === index ? 'ring-2 ring-blue-500' : ''
                }`}
                onMouseEnter={() => setActiveFeature(index)}
                role="button"
                aria-pressed={activeFeature === index}
                tabIndex={0}
              >
 
                <h3 className="mt-8 text-xl font-medium text-gray-900">{feature.title}</h3>
                <p className="mt-4 text-base text-gray-500">{feature.desc}</p>
    
              </div>
            ))}
          </div>
        </div>
      </div>
      <Tooltip />
    </section>
  )
}